<template>
<LayoutGradient :title="$t('dexpara.tipo.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
    <b-card class="col-md-9" body-class="p-0">
        <DeXParaSimpleFilter @search="searchValues"/>

        <TableSimple
            :fields="fields"
            :items="values"
            :loading="isLoading || DeXParaIsLoading"
            :paginator="pagination"
            :text-empty="$t('dexpara.tipo.empty')"
            thead-class="h5 text-center"
            @paginate="paginateTypes"
            borderless
            marginless
            hover
        >
            <template v-slot:cell(origin)="linha">
                <form-group-float-label
                    :label="linha.item.name"
                    :input-name="`input-origem-${linha.index}`"
                    :disabled="!integrationsSelected.origin"
                    v-model="linha.item.origin_code"
                    mandatory
                />
                <b-button size="sm" variant="link" @click="openLogs(linha);" class="mb-0 p-0" v-if="permissions.includes('logs.detail')">
                    {{ $t('dexpara.filtros.logs') }}
                </b-button>
            </template>
            <template v-slot:cell(destination)="{index, item}">
                <form-group-float-label
                    :label="item.name"
                    :input-name="`input-destino-${index}`"
                    :disabled="!integrationsSelected.destination"
                    v-model="item.destination_code"
                    mandatory
                />
            </template>
            <template #row-details="{ item, index }">
                <b-card :title="$t('dexpara.log.origem')">
                <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                    {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
                </b-card>
                <b-card :title="$t('dexpara.log.destino')" class="mt-2">
                <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                    {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
                </b-card>
            </template>
        </TableSimple>
    </b-card>

    <DeXParaIntegrationsCopy class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara" @save-copy="(evt) => persistDeXParaCopy(evt)">
        <template v-slot:options>
        <b-form-group label="Tipo">
            <SelectType class="mb-3" @input="evt => {tipo = evt; searchValues();}" />
        </b-form-group>
        </template>
    </DeXParaIntegrationsCopy>

    </b-card-group>
</LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaSimpleFilter from "@/pages/dexpara/components/DeXParaSimpleFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import {mapActions, mapGetters, mapMutations} from 'vuex';
import TableSimple from "@/components/TableSimple";
import FormGroupFloatLabel from "@/components/FormGroupFloatLabel";
import DeXParaRepository from "@/repositories/dexpara/Type/TypeInformationRepository";
import SelectType from "@/components/tuevs/Select/SelectType"
import DeXParaIntegrationsCopy from "@/pages/dexpara/components/DeXParaIntegrationsCopy";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
    name: "DeXParaTipo",
    props:{
        type: Boolean
    },
    components: {
        TableSimple,
        FormGroupFloatLabel,
        DeXParaSimpleFilter,
        LayoutGradient,
        SelectType,
        DeXParaIntegrationsCopy
    },
    computed: {
        ...mapGetters({
            filters: 'dexpara/filters',
            values: 'type/value/all',
            isLoading: 'type/value/isLoading',
            pagination: 'type/value/pagination',
            DeXParas: 'dexpara/type/all',
            DeXParaPagination: 'dexpara/type/pagination',
            DeXParaIsLoading: 'dexpara/type/isLoading',
            typeValues: 'type/value/allTypeValues',
        }),
    },
    data() {
        return {
            tipo: null,
            integrationsSelected: {
                origin: null,
                destination: null
            },
            fields: [
                {key: 'origin', label: this.$t('dexpara.tipo.origem'), tdClass: 'w-50'},
                {key: 'destination', label: this.$t('dexpara.tipo.destino'), tdClass: 'w-50'}
            ],
            logItems: [],
            permissions: [],
            canAccessRoot: false
        }
    },
    methods: {
        ...mapActions([
            'integration/search',
            'dexpara/type/listAll',
            'type/value/listAll',
            'type/value/findTypeValues'
        ]),
        ...mapMutations([
            'type/setAll',
            'type/value/setAll',
            'type/value/setAllTypeValues',
            'dexpara/resetFilters'
        ]),
        async openLogs(linha) {
            if (linha.detailsShowing === false) {
                this.logItems[linha.index] = await this.formatLogDetails(linha.item);
            }      

            linha.toggleDetails();
        },
        async formatLogDetails(typeValue) {
            let obj = {}
            let logOrigin = null
            let logDestination = null
            if (!this.DeXParas || this.DeXParas.length === 0) {
                return obj
            }

            let originMapped = this.DeXParas.filter(d => d.mapping_type_value_id === typeValue.id && d.mapping_types_information_code === typeValue.origin_code);
            let destinationMapped = this.DeXParas.filter(d => d.mapping_type_value_id === typeValue.id && d.mapping_types_information_code === typeValue.destination_code);

            if (originMapped && originMapped.length > 0) {
                logOrigin = await AuditRepository.getLastByModelId(originMapped[0].mapping_types_information_id).then(async (response) => {          
                return response.data.data;          
                })
            }

            if (destinationMapped && destinationMapped.length > 0) {
                logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].mapping_types_information_id).then(async (response) => {
                return response.data.data;
                })
            }

            obj.logOrigin = logOrigin;
            obj.logDestination = logDestination;
            return obj
        },
        openHistory(auditId) {
            const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
            window.open(routeData.href, '_blank');
        },
        formatDate(date) {
            return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
        },
        async paginateTypes(pagination) {
            await this.$store.commit('type/value/setPagination', {
                ...this.pagination,
                page: pagination.page,
                per_page: pagination.per_page
            })
            this.searchValues()
        },
        async searchValues() {
            await this['type/value/setAll']([])

            if (this.tipo) {
                let filters = [
                    ['mapping_type_id', '=', (this.tipo ? this.tipo.value : null)]
                ]

                if (this.filters.length > 0) {
                    filters = [...filters, ...this.filters]
                }

                let filterApi = [...filters];
                let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
                let hasCodeFilter = filterApi.some(f => f[0] === "code_mapping");

                if (!hasIntegrationFilter && hasCodeFilter) {
                    if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
                        filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
                    }
                }
                
                await this['type/value/listAll']({
                    ...this.pagination,
                    filters: filterApi
                })
            }

            if(this.values.length > 0) {
                this.searchDeXparas()
            }
        },
        async searchDeXparas() {
            let filters = [
                ['mapping_type_value_id', 'IN', this.values.reduce((accumulator, current) => [...accumulator, current.id], [])],
                ['vns_integration_id', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination].filter(i => i !== null)],
                ['mapping_type_id', '=', (this.tipo ? this.tipo.value : null)]
            ]
            if (this.tipo && (this.integrationsSelected.origin || this.integrationsSelected.destination)) {
                await this['dexpara/type/listAll']({
                    //...this.DeXParaPagination,
                    per_page: this.DeXParaPagination.per_page * 2,
                    filters
                })
                await this.loadIntegrationsCodes()
            }
        },
        getDeXpara(tuevs_valor_id, integration_id) {
            if (this.DeXParas && Array.isArray(this.DeXParas)) {
                
                return this.DeXParas.find(valor => 
                    valor.vns_integration_id === integration_id &&
                    valor.mapping_type_value_id === tuevs_valor_id
                )
            }
            return null
        },
        async loadIntegrationsCodes() {
            if (this.values && Array.isArray(this.values)) {
                const valores = this.values.map(valor => {
                    const origin_mapped = this.getDeXpara(valor.id, this.integrationsSelected.origin)
                    valor.origin_code = origin_mapped ? origin_mapped.mapping_types_information_code : null

                    const destination_mapped = this.getDeXpara(valor.id, this.integrationsSelected.destination)
                    valor.destination_code = destination_mapped ? destination_mapped.mapping_types_information_code : null

                    return valor
                })
                this.$store.commit('type/value/setAll', valores)
            }
        },
        async updateIntegrations(evt) {
            this.integrationsSelected.origin = this.integrationsSelected.destination = null

            let originLabel = this.$t('dexpara.tipo.origem')
            if (evt.origin) {
                originLabel = evt.origin.label
                this.integrationsSelected.origin = evt.origin.value
            }

            let destinationLabel = this.$t('dexpara.tipo.destino')
            if (evt.destination) {
                destinationLabel = evt.destination.label
                this.integrationsSelected.destination = evt.destination.value
            }

            this.fields = [{key: 'origin', label: originLabel}, {key: 'destination', label: destinationLabel}]
            await this.searchDeXparas()
        },
        async persistDeXParaCopy(evt) {
            this.copySelected = evt;

            if (this.copySelected.integration_type === null || this.copySelected.integration_to === null) {
                this.$snotify.error(this.$t('dexpara.copia.erro.vazio'))
                return;
            }

            if (this.copySelected.integration_type.value === 'origin' && !this.integrationsSelected.origin) {          
                this.$snotify.error(this.$t('dexpara.copia.erro.integracao_origem'))
                return;
            }

            if (this.copySelected.integration_type.value === 'destiny' && !this.integrationsSelected.destination) {
                this.$snotify.error(this.$t('dexpara.copia.erro.integracao_destino'))
                return;
            }

            if (!this.tipo) {
                this.$snotify.error(this.$t('dexpara.copia.erro.tipo'))
                return;
            }

            this.$snotify.clear()
            this.$snotify.confirm(
                this.$t('dexpara.copia.confirmacao.mensagem'),
                this.$t('dexpara.copia.confirmacao.titulo'),
                {
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [
                    {
                        text: this.$t('dexpara.copia.sim'),
                        action: async toast => {
                        this.$snotify.remove(toast.id)

                        await this['type/value/setAllTypeValues']([])

                        if (this.filters.length > 0) {
                            await this['type/value/findTypeValues']({                            
                            filters: this.filters
                            })
                        }

                        let filterTypeValues = [
                            ['mapping_type_value_id', 'IN', this.typeValues.reduce((acc, current) => [...acc, current.id], [])]
                        ]
                        
                        await DeXParaRepository.postCopy(
                            {
                            copy: this.copySelected,
                            integrations: this.integrationsSelected,
                            type: this.tipo,
                            typeValues: filterTypeValues
                            }
                        ).then(async () => {
                            this.$snotify.success(this.$t('dexpara.copia.sucesso'))
                        }).catch(error => {
                            this.$snotify.error(this.$t('dexpara.copia.erro.copiar'))
                        })
                        },
                        bold: true
                    },
                    {
                        text: this.$t('dexpara.copia.nao'),
                        action: toast => {
                        this.$snotify.remove(toast.id)
                        },
                        bold: true
                    }
                    ]
                }
            )
        },
        async persistDeXPara() {
            let parsedInserts = []
            let parsedUpdates = []

            if (!this.tipo) {
                this.$snotify.warning(this.$t('dexpara.tipo.selecione_tipo'))
                return
            }

            if (this.integrationsSelected.origin) {
                let integrationId = this.integrationsSelected.origin
                
                this.values.filter(e => e.origin_code !== null)
                    .map(valor => {
                        let dexpara = {
                            vns_integration_id: integrationId,
                            mapping_type_id: valor.mapping_type_id,
                            mapping_type_value_id: valor.id,
                            code: valor.origin_code
                        }
                        let DeXPara = this.getDeXpara(valor.id, integrationId)
                        if (DeXPara) {
                            dexpara = {...dexpara, id: DeXPara.mapping_types_information_id}
                            if (valor.origin_code === ''){
                                dexpara = {...dexpara, code: DeXPara.code, delete: true}
                            }
                            parsedUpdates.push(dexpara)
                            return
                        }
                        parsedInserts.push(dexpara)
                    })
            }

            if (this.integrationsSelected.destination) {
                let integrationId = this.integrationsSelected.destination
                this.values.filter(v => v.destination_code !== null)
                    .map(valor => {
                        let dexpara = {
                            vns_integration_id: integrationId,
                            mapping_type_id: valor.mapping_type_id,
                            mapping_type_value_id: valor.id,
                            code: valor.destination_code
                        }
                        let DeXPara = this.getDeXpara(valor.id, integrationId)
                        if (DeXPara) {
                            dexpara = {...dexpara, id: DeXPara.mapping_types_information_id}
                            if (valor.destination_code === ''){
                                dexpara = {...dexpara, code: DeXPara.code, delete: true}
                            }
                            parsedUpdates.push(dexpara)
                            return
                        }
                        parsedInserts.push(dexpara)
                    })
            }

            let insertedError = 0;
            if (parsedInserts.length > 0) {                
                await parsedInserts.map(async dexpara => {
                    await DeXParaRepository.post(dexpara)
                        .then(() => {                            
                        }).catch(() => {
                            insertedError++;
                        });
                })
            }

            let updatedError = 0;
            if (parsedUpdates.length > 0) {
                await parsedUpdates.map(async params => {
                    await DeXParaRepository.put(params.id, params)
                        .then(() => {                            
                        }).catch(() => {
                            updatedError++;
                        });
                })
            }

            if (insertedError > 0 || updatedError > 0) {
                this.$snotify.error(this.$t('dexpara.tipo.depara_erro'))
            }else{
                this.$snotify.success(this.$t('dexpara.tipo.depara_sucesso'))
                this.searchValues()
            }
        }
    },
    async beforeMount() {
        this['dexpara/resetFilters']()
        this.permissions = await getPermissionsFromActualPerfil();
        this.canAccessRoot = await hasPerfil('root');
    },
    async mounted() {
        this.$store.commit('dexpara/type/setPagination', {...this.DeXParaPagination, page: 1})
        this['integration/search']()
    },
    beforeDestroy() {
        this['type/setAll']([])
        this['type/value/setAll']([])
    }
}
</script>

<style lang="scss" scoped>
.sticky-top {
    top: 1.5rem;

    @media only screen and(max-width: 768px) {
        order: -1;
    }
}
</style>
